import {
  applyMiddleware,
  compose,
  createStore,
  Store,
  StoreEnhancerStoreCreator
} from 'redux'
import thunk from 'redux-thunk'

import { IRootState, rootReducer } from '../reducers'
import { hasWindow, isProduction, isServer } from '../utils/envHelper'

export default function configureStore(preloadedState?: IRootState) {
  const devToolsExtension =
    !isServer() &&
    !isProduction() &&
    hasWindow() &&
    (window as any).devToolsExtension
      ? (window as any).devToolsExtension()
      : (f: any) => f

  const enhancer = compose<
    StoreEnhancerStoreCreator<IRootState>,
    StoreEnhancerStoreCreator<IRootState>
  >(applyMiddleware(thunk), devToolsExtension)
  const store = preloadedState
    ? createStore<IRootState>(rootReducer, preloadedState, enhancer)
    : createStore<IRootState>(rootReducer, enhancer)

  const moduleHot = (module as any).hot

  if (moduleHot) {
    // Enable Webpack hot module replacement for reducers
    moduleHot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./common/store/configureStore.ts